/**
 * Запросы к `/api/super-admin/*` (BE-11). Требуют Bearer + DIGPASSADMIN_INGTR.
 *
 * Видимость виджета задаётся **отдельно на каждый уровень территории**
 * (US-09 FR-1, DP-365): область / район-город / сельский округ / село.
 * - `listModules` — свёрнутая форма (`enabled` = конъюнкция по уровням);
 *   используется `ModulesContext`.
 * - `getModulesMatrix` — полная матрица «виджет × уровень» + справочник
 *   уровней; на ней построен экран настроек.
 */
import { api } from './api';

export interface ModuleInfo {
  module_id: string;
  enabled: boolean;
  label_ru: string | null;
  label_kz: string | null;
}

/** Уровень территории. Значения и подписи задаёт бэкенд — не хардкодим. */
export interface KatoLevelInfo {
  value: string;
  label_ru: string | null;
  label_kz: string | null;
}

/** Ячейка матрицы: пара `(module_id, kato_level)`. */
export interface ModuleLevelInfo extends ModuleInfo {
  kato_level: string;
}

export interface ModulesMatrix {
  /** Порядок колонок — серверный. Приходит всегда, даже при пустых modules. */
  levels: KatoLevelInfo[];
  modules: ModuleLevelInfo[];
}

interface ModulesResponse {
  modules: ModuleInfo[];
}

export const listModules = async (): Promise<ModuleInfo[]> => {
  const response = await api.get<ModulesResponse>('/super-admin/modules');
  // Пустое тело ответа → пустой список, а не undefined.
  return response.data?.modules ?? [];
};

export const getModulesMatrix = async (): Promise<ModulesMatrix> => {
  const response = await api.get<ModulesMatrix>('/super-admin/modules/matrix');
  return {
    levels: response.data?.levels ?? [],
    modules: response.data?.modules ?? [],
  };
};

/**
 * Переключить виджет. `katoLevel` не передан → ко всем уровням сразу
 * (поведение прежнего единственного тумблера). Ответ — без `kato_level`.
 */
export const setModuleEnabled = async (
  moduleId: string,
  enabled: boolean,
  katoLevel?: string,
): Promise<ModuleInfo> => {
  const response = await api.put<ModuleInfo>(
    `/super-admin/modules/${moduleId}`,
    katoLevel === undefined ? { enabled } : { kato_level: katoLevel, enabled },
  );
  return response.data;
};
